import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ArrowUpSquareFill } from 'react-bootstrap-icons';
import { getOperationalCatchmentByName } from '../store/reducers/fmAPI.js';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

////const StaticMap = ({ lat, lng, zoom = 13, label, style, geoJSON }) => {
import Loading from '../components/Loading.js';
import GoverningBodyName from '../components/GoverningBodyName';
import CentralLink from '../components/CentralLink.js';

import WaterBodySummaryComponent from '../components/WaterBodySummaryComponent.js';

import MapViewHeaderComponent from '../components/MapViewHeaderComponent.js';

import BreadcrumbComponent from '../components/BreadcrumbComponent.js';

import CommonHeaders from '../components/helmet-headers/CommonHeaders.js';
import Breadcrumbs, { CRUMBS } from '../components/helmet-headers/Breadcrumbs.js';
import GoverningBodyFlag from '../components/GoverningBodyFlag.js';

import loadable from '@loadable/component';

import TLDHelper from '../lib/tldHelper.js';

const StationMapMarkerLegendComponent = loadable(() => import('../components/StationMapMarkerLegendComponent.js'), { ssr: false });
const StationMapMarkerComponent = loadable(() => import('../components/StationMapMarkerComponent.js'), { ssr: false });

function OperationalCatchmentsView(props) {
	const params = useParams();
	const dispatch = useDispatch();
	const { operationalCatchment } = useSelector(state => state.fmAPI);

	useEffect(() => {
		dispatch(getOperationalCatchmentByName(params.operationalCatchmentName));
	}, [dispatch, params.operationalCatchmentName]);

	if(!operationalCatchment[params.operationalCatchmentName]) {
		return <Loading />;
	}

	let activeCatchment = operationalCatchment[params.operationalCatchmentName];

	let waterBodiesSorted = [...activeCatchment.waterBodies].sort((a, b) => a.waterBodyName.localeCompare(b.waterBodyName));


	let mapViewHeaderGeoJSON = activeCatchment && activeCatchment.polygon ? activeCatchment.polygon : waterBodiesSorted.reduce(function(acca, waterBody) {
		acca.features.push({
			"type": "Feature",
			"properties": {},
			"geometry": waterBody.polygon
		});
		return acca;
	}, {
		"type": "FeatureCollection",
		"features": []
	});


	return <div>
		<CommonHeaders
			title={"Operational Catchment - "+activeCatchment.operCatchmentName}
			canonicalUrlPath={"/data-explorer/operational-catchments/"+activeCatchment.operCatchmentName}
			canonicalDefaultWebsite={TLDHelper.mapGoverningBodyToPrimaryWebsite(activeCatchment.governingBody)}
			description={"View catchment summary information, such as river levels and rainfall, for the "+ activeCatchment.operCatchmentName +" operational catchment."}
		/>
		<Breadcrumbs
			builtinCrumbs={[CRUMBS.HOME, CRUMBS.DATA_EXPLORER/*, CRUMBS.OPERATIONAL_CATCHMENTS*/]}
			leafCrumbs={[{
				name: activeCatchment.operCatchmentName,
				path: "/data-explorer/operational-catchments/"+activeCatchment.operCatchmentName
			}]}
		/>
		<Row className="screen-bottom-border">
			<Col xs={12} lg={1} xl={2} className="d-none d-lg-block large-screen-left">&nbsp;</Col>
			<Col xs={12} lg={10} xl={8}>
				<BreadcrumbComponent
						riverBasinName={activeCatchment.riverBasinName}
						mgmtCatchmentName={activeCatchment.mgmtCatchmentName}
						operCatchmentName={null}
						waterBodyName={null}
						leafText={activeCatchment.operCatchmentName}
					/>
				<Row>
					<Col xs={12}>
						<MapViewHeaderComponent
								label=<span><GoverningBodyFlag governingBody={activeCatchment.governingBody} padRight/>{activeCatchment.operCatchmentName}</span>
								geoJSON={mapViewHeaderGeoJSON}
								isStatic={false}
								overrideHeight="330px"
							>
								<StationMapMarkerLegendComponent />
								{activeCatchment.stations && activeCatchment.stations.map(function(station) {
									return <StationMapMarkerComponent
										stationName={station.stationName}
										riverName={station.riverName}
										stationId={station.stationId}
										lat={station.lat}
										lng={station.lng}
										typicalRangeHigh={station.typicalRangeHigh}
										currentHeight={station.currentHeight}
										stationPrimaryMetricType={station.stationPrimaryMetricType}
									/>
								})}
							</MapViewHeaderComponent>
					</Col>
				</Row>
				{activeCatchment.mgmtCatchmentName && <Row style={{borderBottom: "1px dashed grey"}}>
					
					<Col xs={8}>This operational catchment is part of the <b><i>{activeCatchment.mgmtCatchmentName}</i></b> management catchment and is managed by <b><i><GoverningBodyName governingBody={activeCatchment.governingBody} /></i></b></Col>
					<Col xs={4} style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "2px", marginBottom: "2px" }}>
					    <CentralLink to={"/data-explorer/management-catchments/"+activeCatchment.mgmtCatchmentName}>
					    <Button variant="dark" size="sm">
					            View Management Catchment <ArrowUpSquareFill />
					        </Button>
					    </CentralLink>
				    </Col>
					
				</Row>}
				<div>
					{/*JSON.stringify(activeCatchment)*/}
					{waterBodiesSorted.map(function(waterBody) {
						let geoJSON = {
							"type": "FeatureCollection",
							"features": [{
								"type": "Feature",
								"properties": {},
								"geometry": waterBody.polygon
							}]
						};
						return <WaterBodySummaryComponent waterBodyName={waterBody.waterBodyName} polygon={waterBody.polygon} geoJSON={geoJSON} floodAreas={waterBody.floodAreas} waterBodyId={waterBody.waterBodyId}  />
					})}
				</div>
			</Col>
			<Col xs={12} lg={1} xl={2} className="d-none d-lg-block large-screen-right">&nbsp;</Col>
		</Row>
	</div>;
}

export default OperationalCatchmentsView;